import {TriggerQuery} from '@models/adminstration/machine/trigger/trigger-query/trigger-query';

export class ApiConfigurationDetails {
  id?: number = undefined;
  url: string = '';
  triggerQuery: TriggerQuery = new TriggerQuery(-1);
  isActive: boolean | null = null;
  maxRequestsPerHour: number = 0;
  requestsLastHour: number | null = null;
}